<coreui-badge *ngIf = "!tooltipMessage" [color]="color" [iconStatus]="true" class="iconBackground">
    <i [coreUIIcon]="icon" [ngClass] ="customClass"></i>
</coreui-badge>
<coreui-badge *ngIf = "tooltipMessage" [color]="color" [iconStatus]="true" class="iconBackground">
    <i [coreUIIcon]="icon" [coreUITooltip]="tooltipMessage" [ngClass] ="customClass"></i>
</coreui-badge>